import React, { useEffect, useState } from 'react'
import FolderSidebar from '../global/FolderSidebar'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Resource, ResourceFile, User } from '../../utils/interfaces';
import { config } from '../../config';
import { databaseName } from '../../utils/constants';
import ResourceEditor from '../global/ResourceEditor';
import { copy, fileExist, findFile, getContentFromBucket } from '../../utils/functions';

const ResourceDev = ({ user, setUser }: { user: undefined | null | User, setUser: React.Dispatch<React.SetStateAction<undefined | null | User>> }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [resource, setResource] = useState<undefined | null | Resource>(undefined);
  const [openingFiles, setOpeningFiles] = useState<ResourceFile[]>([]);
  const [selectedFile, setSelectedFile] = useState<ResourceFile | null>(null);
  const [jarContent, setJarContent] = useState<ArrayBuffer | null>(null);
  
  useEffect(() => {
    if (user === null) setUser({ username: 'user', avatar: '' })
  }, [user]);

  // load resource
  useEffect(() => {
    if (user) {
      (async () => {
        try {
          const res: Resource = await (await fetch(`${config.api.database}?table=${databaseName}_resources&num=one&key=id&value=${params.id}`)).json();
          // user is not author
          if (res.author !== 'user' && res.author !== user?.username) navigate('/page-not-found');
          setResource(res);
          await loadJarContent(user, res);
        } catch (error) {
          // resource not exist
          navigate('/page-not-found');
        }
      })();
    }
  }, [user, location.pathname]);

  useEffect(() => {
    if (resource) {
      // close files that no longer exists
      // reset opening files and selected file
      setOpeningFiles([...openingFiles].filter(f => f.id === 'config' ? true : fileExist(f.id, resource.root)).map(f => f.id).map(id => id === 'config' ? { id: 'config', name: 'Configuration' } : copy(findFile(id, resource.root))) as ResourceFile[]);
      if (selectedFile) {
        setSelectedFile(selectedFile.id === 'config' ? { ...selectedFile } : copy(findFile(selectedFile.id, resource.root)));
      }
      document.title = `${resource.name} - Online Minecraft Plugins Editor`;
    }
  }, [resource]);

  // open file
  const openFile = (file: ResourceFile) => {
    setOpeningFiles(openingFiles.find(f => f.id === file.id) ? openingFiles : [...openingFiles, file]);
    setSelectedFile(file);
  }

  // close file
  const closeFile = (id: string) => {
    const newList = [...openingFiles].filter(f => f.id !== id);
    setOpeningFiles(newList);
    if (selectedFile?.id === id) {
      setSelectedFile(newList[0] || null);
    }
  }

  // load jar content
  const loadJarContent = async (user: User, resource: Resource) => {
    // load jar file if exist
    const { content, contentType } = await getContentFromBucket(`${user?.username}/${resource?.id}/${resource?.id}.jar`);
    if (content) {
      setJarContent(content);
    }
  }

  return (
    (resource && user) ?
      <main className='flex flex-1 scroller flex-col md:flex-row'>
        <FolderSidebar user={user} resource={resource} setResource={setResource} openFile={openFile} jarContent={jarContent} />
        <ResourceEditor user={user} resource={resource} setResource={setResource} openingFiles={openingFiles} setOpeningFiles={setOpeningFiles} closeFile={closeFile} selectedFile={selectedFile} setSelectedFile={setSelectedFile} jarContent={jarContent} loadJarContent={loadJarContent} />
      </main>
      : <></>
  )
}

export default ResourceDev